import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import swal from "sweetalert";
import PropTypes from "prop-types";
import classnames from "classnames";
import {
  useHistory,
  withRouter,
  Route,
  Redirect,
  Switch,
} from "react-router-dom";
import {
  withStyles,
  makeStyles,
  useTheme,
  withTheme,
} from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import BusinessIcon from "@material-ui/icons/Business";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import Alert from "@material-ui/lab/Alert";
import Loader from "../loaders/loader";

/**ICON */
import InboxIcon from "@material-ui/icons/Inbox";
import DraftsIcon from "@material-ui/icons/Drafts";
import AutorenewIcon from "@material-ui/icons/Autorenew";
import BlockIcon from "@material-ui/icons/Block";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import EmojiPeopleIcon from "@material-ui/icons/EmojiPeople";
import StarBorderIcon from "@material-ui/icons/StarBorder";
import InfoIcon from "@material-ui/icons/Info";

import Badge from "@material-ui/core/Badge";
import MailIcon from "@material-ui/icons/Mail";

import { connect } from "react-redux";
import ApiServices from "../../api/api";
import SurveyList from "./SurveyList";

import ReportList from './ReportList';
import OffileDb from '../../config/pouchDB';
import SurveyForm from './SurveyForm';
import { gaLogEvent } from "../../helpers/analytics";
import cordovaConfig from '../../config/cordovaConfig';

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
}));

class Survey extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      surveyList: [],
      value: 0,
      caseReportList: [],
      caseOfflineReportList: [],
      offileReportIndex: 0,
      tabList: []
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeIndex = this.handleChangeIndex.bind(this);
  }

  componentDidMount() {
    gaLogEvent("Survey", '', '');
    cordovaConfig.init();
    OffileDb.setDatabase()
    this.getTablist()
    this.loadOfflineData()
    this.checkActiveTab()
    // if (navigator.onLine) {
    //   this.getSurveyDetails();
    // }
  }

  getTablist() {
    var menuList = JSON.parse(localStorage.getItem("menuList"));
    var tab = menuList.filter(obj => obj.path == 'survey');
    if (tab.length > 0) {
      this.setState({
        tabList: tab[0].childs.filter(obj => obj.isactive && obj.visible),
      });
    }
  }

  checkActiveTab() {
    var activetab = JSON.parse(sessionStorage.getItem('activeTab'))
    if (activetab != null && activetab['survey'] != undefined) {
      this.setState({
        value: activetab['survey'],
      });
      if(activetab['survey'] == 1) {
        this.getReportList()
      }
    }
  }

  getReportList() {

    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
        languageId: parseInt(this.props.langId),
        userId: JSON.parse(localStorage.getItem('obj')).userId
      };
      ApiServices.getCaseSetForSurveyByUserId(param).then((res) => {
        try{
          console.log(this.state.surveyList, res.data)
          if (res.data.status == 200) {
            Object.entries(res.data.data).forEach(entry => {
              const [key, value] = entry;
              console.log(value)
              var sname = this.state.surveyList.filter(s => s.id == value.surveyId)[0]['name']
              value['surveyName'] = sname;
              value['formType'] = 'caseform';

            })

            res.data.data.sort(function (a, b) {
              return new Date(b.createdAt) - new Date(a.createdAt);
            });

            this.setState({
              caseReportList: res.data.data,
              isLoading: false
            });
            OffileDb.setData('surveyReportList', res.data.data)
            this.loadSruveyOfflineReportList()
          }
        }catch(err){
          console.log("err::", err)
        }
      });
    } else {
      this.loadOfflineReportData()
    }
    this.setState({
      isLoading: false
    });
  }

  getSurveyDetails() {
    var param = {
      communityId: this.props.communityuid,
      languageId: parseInt(this.props.langId)
    };
    ApiServices.getSurveyByCommunityId(param).then((res) => {
      try{
        if (res.data.data.length > 0) {
          this.setState({ surveyList: res.data.data, isLoading: false });
          OffileDb.setData('surveyList', res.data.data)
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  handleChange(event, newValue) {
    this.setState({
      value: newValue,
      isLoading: true
    }, () => {
      this.getReportList();
    });
    sessionStorage.setItem('activeTab', JSON.stringify({ 'survey': newValue }))
  }

  handleChangeIndex(index) {
    this.setState({
      value: index,
      isLoading: true
    }, () => {
      this.getReportList();
    });
    sessionStorage.setItem('activeTab', JSON.stringify({ 'survey': index }))
  }

  loadOfflineData() {
    var that = this
    OffileDb.getData('surveyList').then(function (result) {
      if (result.status && result.status == 404) {
        that.getSurveyDetails()
      } else {
        that.setState({
          surveyList: result.data,
          isLoading: false
        });
      }
    });
  }

  loadOfflineReportData() {
    var that = this
    OffileDb.getData('surveyReportList').then(function (result) {
      if (result.status && result.status == 404) {
      } else {
        that.setState({
          caseReportList: result.data,
          isLoading: false
        });
        that.loadSruveyOfflineReportList()
      }
    });
  }

  loadSruveyOfflineReportList() {
    var that = this
    var caseReportList = this.state.caseReportList
    OffileDb.getData('surveyOfflineReportList').then(function (result) {
      if (!result.status && result.status != 404) {
        if (result.data.length > 0) {
          caseReportList = [...caseReportList, ...result.data];
          that.setState({
            caseReportList: caseReportList,
            caseOfflineReportList: result.data,
            isLoading: false
          });
          if (navigator.onLine) {
            that.submitOfflineReport()
          }
        }
      }
    })
  }

  submitOfflineReport() {
    const { t } = this.props;
    if (this.state.offileReportIndex != this.state.caseOfflineReportList.length) {
      this.submitReportToApiData(this.state.caseOfflineReportList[this.state.offileReportIndex])
    } else {
      swal({
        text: t("Data synced successfully"),
        icon: "success",
        button: t("ok"),
      }).then((val) => {
        this.getReportList()
        OffileDb.removeData('surveyOfflineReportList')
      });
    }
  }

  submitReportToApiData(params) {
    var self = this;
    var num = this.state.offileReportIndex + 1;
    ApiServices.addCaseSetForSurveyUsingPOST(params).then((res) => {
      try{
        if (res.data.status == 200) {
          this.setState({ offileReportIndex: num })
          this.submitOfflineReport()
        }
      }catch(err){
        console.log("err::", err)
      }
    });
  }

  render() {
    const { classes, theme } = this.props;
    const { t } = this.props;
    const { templateID } = this.props;
    let colorStyles = templateID == 2 ? { background: this.props.componentbgcolor } : {};
    let bgStyles = templateID == 2 ? { background: `url(${this.state.background})` } : {};

    let reportList = [];
    this.state.caseReportList.map(caseobj => {
      reportList.push(<ReportList caseobj={caseobj} />)
    })


    if (this.state.isLoading) {
      reportList = <Loader isLoading={this.state.isLoading} />
    } else if (reportList.length == 0) {
      reportList = <h5>{t('No Record Found')}</h5>
    }
    return (
      <div className="gkdivcontent getknowledgeable_page">
        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }
       
          <AppBar className="tabheader" position="static" color="default" style={colorStyles}>
            <Tabs
              value={this.state.value}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor={templateID == 1 ? "primary" : "#fff"}
              variant="fullWidth"
              aria-label="full width tabs example"
            >
              {
                this.state.tabList.length > 0 ? (
                  this.state.tabList.map((tabListObj, index) => {
                    return (<Tab label={t(tabListObj.label)} {...a11yProps(index)} />)
                  })
                ) : (<h5>{t('No Record Found')}</h5>)
              }
              {/* <Tab label={t('Survey')} {...a11yProps(0)} />
            <Tab label={t('Summary')} {...a11yProps(1)} /> */}
            </Tabs>
          </AppBar>
          <SwipeableViews
            axis={theme.direction === "rtl" ? "x-reverse" : "x"}
            index={this.state.value}
            onChangeIndex={this.handleChangeIndex}
            className="infotabcontainer getaccesstabspage getinvolvedtabsmainholder"
          >

            {this.state.tabList.length > 0 &&
              this.state.tabList.map((tabListObj, index) => {
                return (
                  <TabPanel value={this.state.value} index={index} dir={theme.direction}>
                    {tabListObj.componentId == 33 || tabListObj.path == "survey" ?
                      (<div className={this.state.surveyList.length > 1 ? "forumlistdivholder servicesList white_bg" : "forumlistdivholder servicesList"}>
                        {this.state.surveyList.length > 0 ? (
                           this.state.surveyList.length > 1 ? (
                            this.state.surveyList.map((serviceObj) => {
                              serviceObj['formType'] = 'surveyform';
                              return <SurveyList serviceObj={serviceObj} languageId={this.props.langId} />;
                            })
                          ) : (
                            <SurveyForm tablist={this.state.tabList} inlineForm={true} serviceObj={this.state.surveyList[0]} handleChangeIndex={(i) => this.handleChangeIndex(i)}></SurveyForm>
                          )
                        ) : (<h5>{t('No Record Found')}</h5>)
                        }
                      </div>) : (
                        tabListObj.componentId == 34 || tabListObj.path == "summary" ? (
                          <Grid
                            container
                            spacing={3}
                            className="gridcontainer case-report maplistcontainerdiv repostListContainer"
                          >
                            {reportList}
                          </Grid>
                        ) : ('')
                      )
                    }
                  </TabPanel>
                )
              })
            }

          </SwipeableViews>
       
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    componentbgcolor: storeState.componentbgcolor
  };
};

// export default connect(mapStateToProps)(Services);

const transSurvey = withTranslation()(Survey);
const ThemeSurvey = withTheme(transSurvey);
const FinalSurvey = withStyles(useStyles)(ThemeSurvey);
const routeSurvey = withRouter(FinalSurvey);
export default connect(mapStateToProps, {})(routeSurvey);
